import { ConfigurationLayout } from '../models/configuration-layout.model';
import { Configuration } from '../models/configuration.model';

export const getDefaultLayout = (configuration: Configuration): ConfigurationLayout | undefined => {
    return configuration.layouts?.find((l) => l.variableName === 'defaultLayout');
};
